// StudyAbroadIntro.js
import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';

const StudyAbroadIntro = () => {
  const considerations = [
    'Working out entry criteria and whether a course suits your background',
    'Narrowing down destinations, universities and fields of study',
    'Building an application and a personal statement that hold up',
    'Keeping to deadlines and chasing responses when they are late',
    'Deciding on the money and the practicalities of moving'
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12">
          {/* Left Side - Heading */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl md:text-4xl font-semibold text-primary">
              The Reality Behind an Overseas Degree
            </h2>
          </motion.div>
          
          {/* Right Side - Content */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <p className="text-gray-600 text-sm font-light leading-relaxed mb-6">
              Picking a destination and a university is only where it starts. Behind that decision sits a run of practical work: checking what you qualify for, planning the sequence, assembling documents that stand up to scrutiny, and knowing what each institution expects and by when.
            </p>
            
            <p className="text-gray-600 text-sm font-semibold mb-4">
              The journeys that end well tend to share these parts:
            </p>
            
            <ul className="space-y-3">
              {considerations.map((item, index) => (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.2 + (index * 0.1) }}
                  className="flex items-start gap-3"
                >
                  <CheckCircle size={16} className="text-gray-600 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-600 text-sm font-light">{item}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default StudyAbroadIntro;
